<template>
  <div class="container">
    <!-- 头部 -->
    <div class="head">
      <CommonFilter @change="filterData"></CommonFilter>
      <el-input class="search" placeholder="搜索长者" v-model="search" @input="currentPage = 1">
        <el-image class="search-image" slot="prefix" :src="sousuo" fit="contain"></el-image>
      </el-input>
    </div>

    <!-- 列表 -->
    <div class="three-item-list" v-if="list.length">
      <div class="nursing-item" v-for="(item, index) in list" :key="item.Id" :id="'lv-list' + index" @click="goImplement(item.Id)">
        <div class="left">
          <el-image class="nursing-image" fit="cover" :src="item.ImgUrl || avatar"></el-image>
          <div class="name-message">
            <p class="name-message-main">
              <span class="name">{{ item.Name }}</span>
              <span class="message">{{ item.CareLevel }}</span>
            </p>
            <p class="room-message">
              <span class="room">房号:</span>
              <span class="room-num">{{ item.Room }}</span>
            </p>
          </div>
        </div>
        <div class="right">
          <div class="badge">
            <div class="project">服药项目</div>
            <div class="totalCare">
              <div class="three-num-span">{{ item.TotalCare > 99 ? '99+' : item.TotalCare }}</div>
            </div>
          </div>
          <div class="badge">
            <div class="await">待执行</div>
            <div class="totalCare">
              <div class="three-num-span">{{ item.NotExecuted > 99 ? '99+' : item.NotExecuted }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tips v-else></tips>

    <!-- 分页 -->
    <el-pagination
      background
      class="pagination"
      :current-page="currentPage"
      :page-size="pagesize"
      :pager-count="5"
      layout="total,  prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import nursingItem from '@/common/nursing-item.vue'
import pager from '@/common/pager.vue'
import tips from '@/common/tips.vue'
import CommonFilter from '@/common/common-filter.vue'

import photo from '@/assets/imgs/photo.png'
import avatar from '@/assets/imgs/avatar.png'
import sousuo from '@/assets/imgs/icon-sousuo-32@2x.png'
export default {
  props: {
    userList: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    nursingItem,
    CommonFilter,
    pager,
    tips
  },
  // 组件状态值
  data() {
    return {
      search: '',
      roomArr: [],
      currentPage: 1,
      pagesize: 15,
      total: 0,
      photo,
      avatar,
      sousuo
    }
  },
  computed: {
    // tab切换
    list() {
      if (this.userList.ElderlyCares) {
        let resultData = this.userList.ElderlyCares
        // 筛选房间
        if (this.roomArr.length) {
          resultData = resultData.filter((val) => this.roomArr.find((el) => el === val.Room))
        }
        // 长者筛选
        if (this.search) {
          resultData = resultData.filter((val) => val.Name.indexOf(this.search) > -1)
        }
        this.total = resultData.length
        // 分页
        return resultData.slice((this.currentPage - 1) * this.pagesize, (this.currentPage - 1) * this.pagesize + this.pagesize)
      } else {
        return []
      }
    }
  },

  // 组件方法
  methods: {
    // 用户详情
    goImplement(id) {
      this.$emit('change', id)
    },

    // 筛选
    filterData(room) {
      this.currentPage = 1
      this.roomArr = room
    },

    // 分页
    handleCurrentChange(size) {
      this.currentPage = size
      this.$nextTick(() => {
        document.getElementById('lv-list0').scrollIntoView(false)
      })
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.head {
  width: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  box-sizing: border-box;
}

.search-image {
  width: 16px;
  height: 16px;
  margin: 9px 4px 10px 10px;
}
.search,
.head >>> .el-input__inner {
  width: 274px;
  height: 35px;
  font-size: 12px;
  background: #f4f4f4;
  border: 1px solid #f4f4f4;
}
.search {
  font-size: 14px;
}
.head >>> .el-input--prefix .el-input__inner {
  padding-left: 32px;
}

.three-item-list {
  flex: 1;
  padding: 12px;
  overflow-y: auto;
}

.nursing-item {
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 23px 0px 12px;
  margin-bottom: 12px;
  background: #fff;
}
.left {
  display: flex;
  align-items: flex-start;
}
.nursing-image {
  width: 42px;
  height: 42px;
  border-radius: 21px;
  margin-right: 8px;
  border: 1px solid #029fd1;
  box-sizing: border-box;
  margin-top: 6px;
  /* box-shadow: 0px 0px 10px 0px #888888; */
}
.name-message-main,
.room-message {
  margin: 5px 0px 0px 0px;
}
.name-message-main {
  vertical-align: middle;
}
.name {
  font-family: 'PingFang SC Medium';
  font-size: 16px;
  font-weight: 500;
  color: #0a0e10;
  margin-right: 5px;
}
.message {
  font-size: 12px;
  font-weight: 400;
  color: #7c7e80;
}
.room-message {
  font-size: 12px;
  font-weight: 400;
  color: #029fd1;
}
.right {
  font-size: 14px;
  text-align: center;
}
.badge {
  position: relative;
  margin: 13px 0px;
}
.totalCare {
  position: absolute;
  right: -8px;
  top: -8px;
  width: 16px;
  height: 16px;
  line-height: normal;
  background: #f22d2e;
  border-radius: 50%;
}
.three-num-span {
  line-height: 1;
  color: #fff;
  font-size: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5, 0.5);
}
.project {
  width: 75px;
  height: 24px;
  line-height: 24px;
  background: #def7ff;
  border-radius: 2px;
  text-align: center;
  color: #029fd1;
  font-family: 'PingFang SC Medium';
}
.await {
  width: 75px;
  height: 24px;
  line-height: 24px;
  color: #7d4304;
  background: #fef3e7;
  border-radius: 2px;
  text-align: center;
  font-family: 'PingFang SC Medium';
}
.right >>> .el-badge__content {
  padding: 6px 2px;
  border-radius: 12px;
  min-width: 19px;
  font-size: 8px;
  right: 11px;
}
.photo {
  width: 22px;
  height: 22px;
  margin-left: -3px;
}

.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/medicine/one.vue